// Translation: Two-factor authentication > Landing > Form (English)
export default Object.freeze({
	form: {
		actions: {
			activate: 'Activate 2FA',
			reload: 'Reload',
			skip: 'Skip'
		},
		fallback: {
			message: 'Please reload the page'
		},
		fields: {
			code: {
				placeholder: 'Enter code'
			}
		},
		title: 'Two-factor authentication'
	}
})
